import React from 'react';
import { TextField, InputAdornment, Typography, Box } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import palette from 'src/theme/palette';

const MultilineInputField = ({
  label,
  name,
  value = '',
  onChange,
  onBlur,
  error,
  helperText,
  placeholder = '',
  backgroundColor,
  disabled,
  fontFamily,
  marginBottom,
  height,
  fontSize,
  color,
  labelColor,
  width,
  rows = 4,
  maxRows = 8,
  labelFontMedium
}) => {
  return (
    <Box
      sx={{
        marginBottom: error ? '0.2rem' : marginBottom || '1rem',
        width: width || '100%'
      }}
    >
      {/* Top Label */}
      {label && (
        <Typography
          sx={{
            fontSize: 12,
            marginBottom: '4px',
            fontFamily: labelFontMedium ? 'poppinsMedium' : 'poppinsRegular',
            color: labelColor ? labelColor : '#1a1a1a'
          }}
        >
          {label}
        </Typography>
      )}

      {/* Multiline Text Field */}
      <TextField
        disabled={disabled}
        fullWidth
        multiline
        rows={rows}
        maxRows={maxRows}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={Boolean(error)}
        helperText={error ? helperText : ''}
        FormHelperTextProps={{
          sx: {
            fontFamily: 'poppinsRegular',
            fontSize: 11,
            marginLeft: '0px',
            marginTop: '4px',
            color: '#7F1D1D'
          }
        }}
        placeholder={placeholder}
        variant="outlined"
        InputProps={{
          endAdornment: error && (
            <InputAdornment position="end" sx={{ marginRight: -1, marginTop: 1 }}>
              <ErrorIcon color="error" sx={{ fontSize: 20 }} />
            </InputAdornment>
          ),
          sx: {
            fontSize: 12,
            color: palette.primary.titledark,
            fontFamily: fontFamily || 'poppinsRegular',
            alignItems: 'flex-start',
            padding: '8px 14px'
          }
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            fontFamily: fontFamily ? fontFamily : 'poppinsRegular',
            fontSize: fontSize ? fontSize : 12,
            color: color ? color : palette.primary.titledark,
            minHeight: height ? height : 'auto',
            borderWidth: 1.5,
            backgroundColor: backgroundColor ? backgroundColor : '#fff',
            '& textarea': {
              padding: '0',
              '&:-webkit-autofill': {
                boxShadow: '0 0 0 1000px #fff inset !important',
                WebkitTextFillColor: palette.primary.titledark,
                transition: 'background-color 5000s ease-in-out 0s'
              }
            },
            '& fieldset': {
              borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder,
              borderWidth: '1.5px'
            },
            '&:hover fieldset': {
              borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder
            },
            '&.Mui-focused fieldset': {
              borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder,
              borderWidth: '1.5px'
            }
          }
        }}
      />
    </Box>
  );
};

export default MultilineInputField;
